import styled from "@emotion/styled";

export const StyleButton = styled.button`
  font-family: Poppins Medium;
  padding: 0.5% 1%;
  border-radius: 10%;
  border: none;
  outline: none;
  cursor: pointer;
  background: ${({ bg }: { color: string; bg: string }) => bg};
  color: ${({ color }: { color: string; bg: string }) => color};
  box-shadow: 0px 3px 6px #00000029;
  min-width: 11ch;
`;
